import { render, staticRenderFns } from "./SelectDoctorOnFile.vue?vue&type=template&id=5300bb00"
import script from "./SelectDoctorOnFile.vue?vue&type=script&lang=js"
export * from "./SelectDoctorOnFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports